module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "权益折扣",
      "visible": _vm.visible,
      "before-close": _vm.handleClose,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "formRef",
    attrs: {
      "model": _vm.formInfo,
      "label-width": "120px",
      "label-position": "right",
      "size": "small",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "折扣名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "折扣名称",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "name", $$v)
      },
      expression: "formInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权益名称",
      "prop": "privilegeName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "权益名称",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.formInfo.privilegeName),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "privilegeName", $$v)
      },
      expression: "formInfo.privilegeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权益code",
      "prop": "privilegeCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "权益code",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.formInfo.privilegeCode),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "privilegeCode", $$v)
      },
      expression: "formInfo.privilegeCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "折扣开始区间",
      "prop": "begin"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "折扣开始区间",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.begin),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "begin", $$v)
      },
      expression: "formInfo.begin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "折扣结束区间",
      "prop": "end"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "折扣结束区间",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.end),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "end", $$v)
      },
      expression: "formInfo.end"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权益折扣",
      "prop": "discount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "权益折扣",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "discount", $$v)
      },
      expression: "formInfo.discount"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-5cb9c120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/privilege/pool/components/discount.vue
// module id = 1678
// module chunks = 0